import config from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';

const fetchChaptersWithPremiumAndFreeCount = async (data) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/frm/question-bank/chapter-wise-count`,
    data,
  );
};
const fetchLastAnsweredQuestion = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/frm/question-bank/last-question-answered`,
    data,
  );
};
module.exports = {
  fetchChaptersWithPremiumAndFreeCount,
  fetchLastAnsweredQuestion,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/ApiService.js